import { Divider } from '@mui/material';
import TextField from '@mui/material/TextField';
import { MemreButton, MemreFlexBox, MemreModal } from 'components/core';
import { useState } from 'react';
import { SurveyQuestion } from 'services/useItem.service/interactions';
import { useAuthoringContext } from '../AuthoringContext';
import AttachInstructionalItem from '../components/AttachInstructionalItem';
import ImageUploadModal from '../components/ImageUpload/ImageUploadModal';
import MultiResponseToggle from '../components/MultiResponseToggle';
import Sound from '../components/Sound';
import SurveyAnswers from '../components/SurveyAnswers';

export default function SurveyQuestionAndAnswers() {
  const surveyQuestionAndAnswers = useAuthoringContext()?.item as SurveyQuestion;
  const [modalContent, setModalContent] = useState<JSX.Element | null>(null);

  const handleAddImage = (addImageMethod) => {
    setModalContent(<ImageUploadModal addImageMethod={addImageMethod} close={() => setModalContent(null)} />);
  };

  return (
    <MemreFlexBox
      direction="column"
      gap={2}
      sx={{
        p: 2,
        pl: 0,
        width: '100%',
      }}
    >
      <MemreFlexBox direction="row" gap={2}>
        <TextField
          label="Question Text"
          variant="outlined"
          sx={{ flex: 1 }}
          value={surveyQuestionAndAnswers.question.text}
          onChange={(e) => surveyQuestionAndAnswers.question.update(e.target.value)}
        />

        {surveyQuestionAndAnswers.image?.url && (
          <MemreFlexBox
            direction="column"
            sx={{ position: 'relative', height: '100%' }}
            align="center"
            justify="center"
          >
            <div
              style={{
                aspectRatio: '1/1',
                height: '100%',
                backgroundImage: `url(${surveyQuestionAndAnswers.image.url})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                borderRadius: '4px',
              }}
            />
            <MemreButton
              variant="icon"
              iconName="trash"
              onClick={surveyQuestionAndAnswers.image.delete}
              sx={{ position: 'absolute', backgroundColor: 'white' }}
            />
          </MemreFlexBox>
        )}

        {!surveyQuestionAndAnswers.image?.url && (
          <MemreButton
            text="Add Image"
            iconName="image"
            variant="outlined"
            size="small"
            onClick={() => handleAddImage(surveyQuestionAndAnswers.image.add)}
          />
        )}
        <Sound
          url={surveyQuestionAndAnswers.sound.url}
          add={surveyQuestionAndAnswers.sound.add}
          handleDelete={surveyQuestionAndAnswers.sound.delete}
        />
      </MemreFlexBox>
      <Divider sx={{ width: '100%', m: 0.5 }} />
      <MultiResponseToggle
        value={surveyQuestionAndAnswers.answerType}
        onChange={surveyQuestionAndAnswers.toggleAnswerType}
      />
      <Divider sx={{ width: '100%', m: 0.5 }} />
      {surveyQuestionAndAnswers?.answers?.map((answer) => (
        <SurveyAnswers
          key={answer.id}
          text={answer.text}
          id={answer.id}
          handleAddImage={handleAddImage}
          image={answer.image}
          deleteAnswer={answer.delete}
          updateAnswer={answer.update}
        />
      ))}
      <MemreButton
        variant="text"
        text="Add Answer"
        size="small"
        iconName="plus"
        onClick={surveyQuestionAndAnswers.addAnswer}
      />

      <Divider sx={{ width: '100%', m: 0.5, mt: 2 }} />

      {surveyQuestionAndAnswers?.id && <AttachInstructionalItem itemId={surveyQuestionAndAnswers.id} />}

      <MemreModal padding={0}>{modalContent}</MemreModal>
    </MemreFlexBox>
  );
}
